import axios, { AxiosResponse } from 'axios';

const routeName = `/payment-options`;


export async function getEventsPaymentOptions(eventId: number): Promise<any> {
    const filter = {
        "where": {
            "eventId": eventId
        },
    }

    return axios.get(process.env.VUE_APP_CJ_API_URL + routeName)
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error getEventsPaymentOptions !',err);
            return {error : err};
        });
}
